module.exports = __webpack_public_path__ + "visa.svg?49f636";


//////////////////
// WEBPACK FOOTER
// ./client/assets/card/visa.svg
// module id = 247
// module chunks = 0